import {
  AnimatePresence,
  domAnimation,
  LazyMotion,
  m as motion,
  MotionValue,
  useTransform,
} from 'framer-motion'

import { FC } from 'react'

import { IChildren, IClassName } from '@/app/shared/interfaces/common.interface'

// interface
interface IScrollTop extends IClassName, IChildren {
  start: string | number
  transform: MotionValue<number>
}

// component
const ScrollTopComponent: FC<Readonly<IScrollTop>> = ({
  children,
  className,
  start,
  transform,
}) => {
  const translateY = useTransform(transform, [0, 1], [start, '0%'], {})
  const opacity = useTransform(transform, [0, 0.5, 1], [0, 1, 1])

  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        <motion.div
          className={className}
          style={{
            y: translateY,
            opacity: opacity,
          }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </LazyMotion>
  )
}

export default ScrollTopComponent
